
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import checkPricingService from '@/apps/shared/services/checkPricing-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import WhatsApp from '@/apps/shared/components/WhatsApp.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import { SaveMultiQuoteNotificationsRequest } from '@/apps/shared/models/saveMultiQuoteNotificationsRequest';
    export default defineComponent({
        components: {
            XBreadcrumb,
            WhatsApp,
        },
        data() {
            return {
                premioMensual: null,
                coberturas: null,
                dataCovers: [],
                data: [],
                selectedValue: null,
                AmparoJson: null,
                QuotationJson: null,
                coverDescription: null,
                selectedPlan: null,
                dataQ: [],
                col: 2,
                plansLength: null,
                breadcrumItems: [
                    { text: 'Inicio', path: '/movilidad' },
                    { text: 'Cotizador de Movilidad', path: '/movilidad/cotizarMovilidad' },
                    { text: 'Valor del Vehiculo', path: '/movilidad/valorVehiculo' },
                    { text: 'Elegi Plan', path: '/valorVehiculo/elegiPlan' },
                ],
                tabOneWelcome: null,
                dataVehicle: null,
                rangeSelected: null,
                leadId: null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Movilidad urbana';
                const actualPath = '/movilidad';
                const actualStep = 'quoted';

                const request = new SaveMultiQuoteNotificationsRequest();
                request.lastName = this.tabOneWelcome.lastName;
                request.firstName = this.tabOneWelcome.firstName;
                request.phone = this.tabOneWelcome.areaCode + this.tabOneWelcome.telephone;
                request.mail = this.tabOneWelcome.email;
                request.quotePlan = this.AmparoJson.map(plan => plan.planDescription).join(' - ');
                request.quotationDetail = "Producto: " + defaultTitle
                                + " - Vehículo: " + this.dataVehicle.productDescription
                                + " - Valor: " + this.rangeSelected.productDescription;

                // Llamamos al helper que se encarga de toda la lógica
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, actualStep, request);
                }
                catch (error) {
                    const statusCode = error.response.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            volver() {
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'movilidad-range-view',
                })
            },
            open: function () {

                this.$refs.modal.open();

            },
            close: function () {
                this.$refs.modal.close();
            },
            selectedPlans: function (quotationData) {
                // se le envia el pricingId del plan que se haya elegido
                var pricingId = parseInt(quotationData.PricingId[0])
                sessionStorage.setItem("PlanSelected", JSON.stringify(quotationData));
                checkPricingService.checkStatePricing(pricingId).then(response => {
                    if (response.errorMessage == "Actualizacion correcta") {
                        this.$router.push({
                            name: 'UrbanMobilityClientData'
                        })
                    }
                    else {
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': JSON.parse(sessionStorage.getItem("TabOneWelcome")).email,
                            'product': 'movilidad',
                            'event': 'errorServidor',
                            'paso': 'cotizador-movilidad-plan',
                            'referente': this.referente
                        });
                    }
                });
            },

            dataAmparos: function () {
                this.dataQ = [];
                var AmparosData = sessionStorage.getItem("ResponseAmparos");
                var DataQuotation = sessionStorage.getItem("DataQuotation");
                if (AmparosData != null) {
                    this.AmparoJson = JSON.parse(AmparosData!);
                    this.plansLength = this.AmparoJson.length;
                    this.QuotationJson = JSON.parse(DataQuotation!);
                    this.QuotationJson.forEach(({ plans, relationId, quotationId }) => {
                        const { finallyCalculationResult, premioMensual, premiumWithoutDiscount, discounts, premioSegunVigencia, pricingId } = plans[0];
                        this.dataQ.push({
                            finallyCalculationResult,
                            premioMensual,
                            premiumWithoutDiscount: premiumWithoutDiscount && premiumWithoutDiscount.toLocaleString('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }),
                            rate: discounts ? discounts[0].rate : null,
                            premioSegunVigencia,
                            PricingId: pricingId,
                            RelationId: relationId,
                            QuotationId: quotationId,
                        });
                    })
                    for (var i = 0; i < this.AmparoJson.length; i++) {
                        var groupOfAmparoTheftOptions = [];
                        Object.assign(this.AmparoJson[i], this.dataQ[i])
                        var value = JSON.parse(JSON.stringify(this.AmparoJson[i]));
                        value.amparoTheftOptions.forEach(({ amparoTypes, amparoTypesDescription, capital, amparoTypesNotes }) => {
                            if (!groupOfAmparoTheftOptions.some(resp => resp.amparoTypes === amparoTypes)) {
                                groupOfAmparoTheftOptions.push({
                                    amparoTypes,
                                    coverDescription: amparoTypesDescription,
                                    capital: parseFloat(capital.toString().replace(/\./g, '')).toLocaleString('de-DE', {
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 0,
                                    }),
                                    amparoTypesNotes
                                });
                            }
                        });
                        const amparo = this.AmparoJson[i];

                        amparo.groupOfAmparoTheftOptions = groupOfAmparoTheftOptions;
                        NF.UI.Page.unblock();

                        amparo.value = { ...amparo };
                        this.coberturas = groupOfAmparoTheftOptions;
                        amparo.premioMensual = parseFloat(amparo.premioMensual.toString().replace(/\./g, '')).toLocaleString('de-DE', {
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                        });
                    }
                }
            },
            async getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                this.tabOneWelcome = JSON.parse(sessionStorage.getItem("TabOneWelcome"));
                this.dataVehicle = JSON.parse(sessionStorage.getItem("ProductDataSelected"));
                this.rangeSelected = JSON.parse(sessionStorage.getItem("ProductValueSelected"));
                this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
                const additionalInformation = {
                    'Producto': this.dataVehicle.productDescription,
                    'Suma asegurada': this.rangeSelected.productDescription,
                };
                CRMCotizadorWebService.CreateOrEditLead(this.leadId, this.tabOneWelcome.email, location.href, this.tabOneWelcome.areaCode, this.tabOneWelcome.telephone, 936, false, "4", additionalInformation, this.tabOneWelcome.lastName, this.tabOneWelcome.firstName);
                this.dataAmparos();
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.tabOneWelcome.email,
                    'product': 'movilidad',
                    'event': 'cotizador-movilidad-valor',
                    'referente': this.referente
                });
                sessionStorage.removeItem("pressBack");
                var fromTabThree = sessionStorage.getItem("FromTabThree");
                var fromTabFour = sessionStorage.getItem("FromTabFour");
                if (fromTabThree == "true" && fromTabFour == "true") {
                    sessionStorage.setItem("FromTabThree", "false");
                } else {
                    sessionStorage.setItem("FromTabThree", "false");
                    sessionStorage.setItem("FromTabFour", "true");
                }
            }
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente; 

                await this.getInitData();

                const parallelPromises = [
                    this.pageCustomization(),
                    this.updateByProductGoogleAnalytics()
                ];

                await Promise.all([
                    ...parallelPromises,
                ]);

            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
